import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  ApiResponse,
  ApiError,
  LinkData,
  PayRequest,
  PayResponse,
  LinkErrorCode
} from '../models/paylink.model';

export class PaylinkApiError extends Error {
  constructor(
    public readonly code: LinkErrorCode | string,
    message: string,
    public readonly httpStatus?: number
  ) {
    super(message);
    this.name = 'PaylinkApiError';
  }
}

@Injectable({
  providedIn: 'root'
})
export class PaylinkService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.paylink.baseUrl;
  private readonly requestTimeout = 20_000;

  /**
   * GET /links/v2/{linkId}
   */
  getLinkData(linkId: string, reservationToken: string): Observable<LinkData> {
    console.log('ENVIRONMENT:', environment);

    let params = new HttpParams()
      .set('reservationToken', reservationToken)

    const url = `${this.baseUrl}/links/v2/${linkId}`;

    return this.http.get<ApiResponse<LinkData>>(url, { params }).pipe(
      timeout(this.requestTimeout),
      map(response => response.data),
      catchError(error => this.handleError(error))
    );
  }

  /**
   * POST /links/v2/{linkId}/pay
   */
  payLink(linkId: string, body: PayRequest): Observable<PayResponse> {
    const url = `${this.baseUrl}/links/v2/${linkId}/pay`;

    return this.http.post<ApiResponse<PayResponse>>(url, body).pipe(
      timeout(this.requestTimeout),
      map(response => response.data),
      catchError(error => this.handleError(error))
    );
  }

  private handleError(error: unknown): Observable<never> {
    if (error instanceof HttpErrorResponse) {
      const body = error.error as ApiError | undefined;

      if (error.status === 409 && body?.message?.code) {
        return throwError(() => new PaylinkApiError(
          body.message.code,
          body.message.text ?? '',
          error.status
        ));
      }

      if (!body?.message?.text) {
        console.warn('[payment-link] HTTP error sin mensaje del backend:', error);
      }
      return throwError(() => new PaylinkApiError(
        'unknown',
        body?.message?.text ?? '',
        error.status
      ));
    }

    if (error instanceof Error && error.name === 'TimeoutError') {
      console.warn('[payment-link] Timeout al conectar con el servicio de pagos');
      return throwError(() => new PaylinkApiError('timeout', ''));
    }

    console.warn('[payment-link] Error inesperado en la llamada HTTP:', error);
    return throwError(() => new PaylinkApiError('unknown', ''));
  }
}
